import React from 'react';
import { UserSearchResult } from '../types';

type UserSearchDataViewProps = {
  results: UserSearchResult[];
  searchParams: {
    name?: string;
    email?: string;
    startDate: string;
    endDate: string;
  };
};

export const UserSearchDataView: React.FC<UserSearchDataViewProps> = ({
  results,
  searchParams
}) => {
  const handleViewDetails = (userId: number) => {
    const url = `/?type=period&userId=${userId}&startDate=${searchParams.startDate}&endDate=${searchParams.endDate}`;
    window.open(url, '_blank');
  };

  if (results.length === 0) {
    return (
      <div className="flex-1 flex items-center justify-center">
        <div className="text-center max-w-md">
          <div className="text-6xl mb-4">🔍</div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            検索結果がありません
          </h3>
          <p className="text-gray-600 mb-2">
            検索条件に一致するユーザーが見つかりませんでした。
          </p>
          <div className="text-sm text-gray-500 mt-4 space-y-1">
            {searchParams.name && <p>ユーザー名: {searchParams.name}</p>}
            {searchParams.email && <p>メールアドレス: {searchParams.email}</p>}
            <p>期間: {searchParams.startDate} 〜 {searchParams.endDate}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex-1 p-6 overflow-y-auto">
      <div className="max-w-7xl mx-auto">
        <div className="mb-6">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            ユーザー検索結果
          </h2>
          <div className="text-gray-600 space-y-1">
            {searchParams.name && <p>ユーザー名: {searchParams.name}</p>}
            {searchParams.email && <p>メールアドレス: {searchParams.email}</p>}
            <p>期間: {searchParams.startDate} 〜 {searchParams.endDate}</p>
            <p className="font-semibold mt-2">検索結果: {results.length}件</p>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow overflow-hidden">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                    ユーザーID
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                    ユーザー名
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                    メールアドレス
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-700 uppercase tracking-wider">
                    計測回数
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-700 uppercase tracking-wider">
                    呼吸アラート<br/>5回以上の日数
                  </th>
                  <th className="px-6 py-3 text-center text-xs font-medium text-gray-700 uppercase tracking-wider">
                    操作
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {results.map((user) => (
                  <tr key={user.user_id} className="hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                      {user.user_id}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                      {user.name}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                      {user.email || '-'}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-right">
                      {user.measurement_count}回
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-right">
                      <span className={`font-medium ${
                        user.high_apnea_days > 0 ? 'text-red-600' : 'text-gray-900'
                      }`}>
                        {user.high_apnea_days}日
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-center">
                      <button
                        onClick={() => handleViewDetails(user.user_id)}
                        className="px-4 py-2 text-sm bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
                      >
                        詳細
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};
